import BaseService from "shared/services/base-service.service"
import axios from "axios";

export default  class LoginService extends BaseService {

    constructor(){
        super("auth");
    }

    async postLogin(argumento = {}, headers ={}) {
        return await axios.post(`rest/auth/token`, argumento, { headers: headers} )
    }

    async postChangePassword(argumento = {}) {
        return await axios.post(`rest/auth/change-password`, argumento)
    }

    async postResetPassword(argumento = {}) {
        return await axios.post(`rest/auth/reset-password`, { params: argumento })
    }
}

